module.exports = __webpack_public_path__ + "static/media/simple-temp.d968e41a.jpeg";